module.exports = __webpack_public_path__ + "img/gigawhat-mockup_mac.e35ead57.svg";